import { ApiMetaDataDTO, UserDTO } from 'declarations'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
}

export const useUserTypeListQuery = (): UseQueryResult<any, unknown> => {
  return useQuery({
    queryKey: ['user_type', 'list'],
    queryFn: async () => {
      try {
        const res = await client.get<ApiResponseDTO>('/userType/list')
        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
}
